// Instagram URL patterns for posts, reels, and IGTV (with and without username)
export const INSTAGRAM_REGEX_GLOBAL = /instagram\.com\/([^\/]+)?\/?(p|reel|tv)\/([^\/\?]+)/g;
export const INSTAGRAM_REGEX = /instagram\.com\/([^\/]+)?\/?(p|reel|tv)\/([^\/\?]+)/;

export interface InstagramUrlData {
  username: string | null;
  contentType: 'p' | 'reel' | 'tv';
  contentId: string;
  fullUrl: string;
}

export const isValidInstagramUrl = (url: string): boolean => {
  return INSTAGRAM_REGEX.test(url);
};

export const extractInstagramData = (url: string): InstagramUrlData | null => {
  const match = url.match(INSTAGRAM_REGEX);
  if (!match) return null;

  const username = match[1] || null;
  const contentType = match[2] as 'p' | 'reel' | 'tv';
  const contentId = match[3];

  return {
    username,
    contentType,
    contentId,
    fullUrl: url,
  };
};

// Test URLs for validation
export const TEST_INSTAGRAM_URLS = [
  // POSTS
  'https://www.instagram.com/apthcry/p/DM5bajPMKMQ/', // post with username
  'https://www.instagram.com/p/DM5bajPMKMQ/?utm_source=ig_web_copy_link', // post without username
  'https://www.instagram.com/p/DM5bajPMKMQ/?utm_source=ig_web_button_share_sheet', // post without username

  // REELS
  'https://www.instagram.com/apthcry/reel/DHyU1CrR5cZ/', // reel with username
  'https://www.instagram.com/reel/DHyU1CrR5cZ/?utm_source=ig_web_copy_link', // reel without username
  'https://www.instagram.com/reel/DHyU1CrR5cZ/?utm_source=ig_web_button_share_sheet', // reel without username
];
